import { render } from "./PhotoMyPhotoTypeTab.vue?vue&type=template&id=58824e9d"
import script from "./PhotoMyPhotoTypeTab.vue?vue&type=script&lang=js"
export * from "./PhotoMyPhotoTypeTab.vue?vue&type=script&lang=js"

import "./PhotoMyPhotoTypeTab.vue?vue&type=style&index=0&id=58824e9d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__